























































































import Vue from 'vue';
import { Component } from 'vue-property-decorator';
import { IDataVueModel } from "@/ts/models/IDataVueModel";
import api, { IResult } from "@/ts/functions";

@Component
export default class Checkout extends Vue {
    name: string = "Checkout";
    isLoading: boolean = true;
    items: IDataVueModel[] = [];
    payments: IDataVueModel[] = [];
    total: number = 0;

    private transactionId: string = "";
    
    mounted() {
        api.checkout(this.$route.params.applicationNumber)
            .then(result => {
                this.items = result.items;
                this.payments = result.payments;
                this.total = result.total - this.getTotalPaid(result.payments);
                this.transactionId = result.id;
            })
            .catch((error: Error) => this.$toaster.error(error.message))
            .finally(() => this.isLoading = false);
    }
    
    payCredit(): void {
        this.isLoading = true;
        api.payCredit(this.$route.params.applicationNumber)
            .then(form => form.submit())
            .catch((error: Error) => this.$toaster.error(error.message));
    }

    payAch(): void {
        this.isLoading = true;
        api.payAch(this.$route.params.applicationNumber, this.$route.params.formName)
            .then(result => {
                this.redirectResult(result);
            })
            .catch((error: Error) => this.$toaster.error(error.message))
            .finally(() => this.isLoading = false);
    }

    payNothing(): void {
        this.$router.push({
            name: "ThankYou",
            params: {
                payType: "EMP",
                applicationNumber: this.$route.params.applicationNumber
            },
            query: this.$route.query
        });
    }

    getTotalPaid(payments: IDataVueModel[]): number {
        let paid: number = 0;
        payments.forEach((payment, index) => {
            paid = ((payment.value as any) - 0) + paid;
        });
        return paid;
    }

    private redirectResult(result: IResult): void {
        if (result.isSuccess) {
            window.location.href = result.message as string;
        } else {
            throw new Error(result.message as string);
        }
    }
}
